<div class="pageWrapper">
  <div class="pageInfo">
    <h2  class="cscMidnightBlueText">Our <span class="cscMidnightBlueText">Associations</span></h2>
    <p class="intro">
      CSC maintains alliances, membership, sponsorship, and/or board positions
      with the organizations listed below. These relationships give CSC access
      to a vast network of relative information as well as to industry experts,
      and in turn, CSC shares this knowledge and expertise with its clients.
    </p>
    <div class="associationList">
      <ng-container *ngFor="let x of list">
        <div class="individual">
          <h3>{{ x.title }}</h3>
          <p class="listCopy">
            {{ x.copy }}
            <ng-container *ngIf="x.subList">
              <div *ngFor="let l of x.subList">
                <div class="subListText">
                  <ng-container *ngIf="l.text !== '- If You See Something Say Something'">
                    <p>{{ l.text }}</p>
                  </ng-container>
                  <ng-container *ngIf="l.text === '- If You See Something Say Something'">
                    <p class="trademark">{{ l.text }}</p>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </p>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="assocImages">
    <div *ngFor="let img of images" class="imageGrid">
      <img loading="lazy"
        style="object-fit: contain; width: 100%"
        [src]="img.imgPath"
        alt="{{ img.imgName }}"
      />
    </div>
  </div>
</div>
